module.exports = __webpack_public_path__ + "static/media/financebanner.191bad68.png";